export default __webpack_public_path__ + "static/media/crown.d28d860f.svg";